
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UnitConversionService {

  convert(value: number, fromUnit: string, toUnit: string): number {
    if (fromUnit === toUnit) return value;
    const key = `${fromUnit}->${toUnit}`;
    const fn = CONVERSIONS_MAP[key];
    if (fn) {
      return fn(value);
    }
    throw new Error(`Conversion not supported: ${fromUnit} -> ${toUnit}`);
  }
}

export const UNITS = {
  TEMPERATURE_F: '°F',
  TEMPERATURE_C: '°C',
  THERMAL_EXP_F: '%/°F',
  THERMAL_EXP_C: '%/°C',
  THERMAL_EXP_F_1: '1/°F',
  THERMAL_EXP_C_1: '1/°C',
  PRESSURE_PSI: 'psi',
  PRESSURE_KSI: 'ksi',
  PRESSURE_MPA: 'MPa',
  PRESSURE_KPA: 'kPa',
  DENSITY_PPG: 'ppg',
  DENSITY_KGM3: 'kg/m3',
  LENGTH_IN: 'in',
  LENGTH_MM: 'mm',
  LENGTH_FT: 'ft',
  LENGTH_M: 'm',
  MASS_PER_LENGTH_LBFT: 'lb/ft',
  MASS_PER_LENGTH_KGM: 'kg/m',
  FORCE_KIPS: 'kips',
  FORCE_KN: 'kN',
  WEIGHT_LB: 'lb',
  WEIGHT_KG: 'kg',
};

const CONVERSIONS_MAP: { [key: string]: (value: number) => number } = {
  // Temperature
  [`${UNITS.TEMPERATURE_F}->${UNITS.TEMPERATURE_C}`]: (v: number) => (v - 32) * 5 / 9,
  [`${UNITS.TEMPERATURE_C}->${UNITS.TEMPERATURE_F}`]: (v: number) => v * 9 / 5 + 32,
  // % x DegF <-> % x DegC
  [`${UNITS.THERMAL_EXP_F}->${UNITS.THERMAL_EXP_C}`]: (v: number) => v * (9 / 5),
  [`${UNITS.THERMAL_EXP_C}->${UNITS.THERMAL_EXP_F}`]: (v: number) => v * (5 / 9),
  // Pressure
  [`${UNITS.PRESSURE_PSI}->${UNITS.PRESSURE_MPA}`]: (v: number) => v * 6.89476e-3,
  [`${UNITS.PRESSURE_MPA}->${UNITS.PRESSURE_PSI}`]: (v: number) => v / 6.89476e-3,
  [`${UNITS.PRESSURE_KSI}->${UNITS.PRESSURE_MPA}`]: (v: number) => v * 6.89476,
  [`${UNITS.PRESSURE_MPA}->${UNITS.PRESSURE_KSI}`]: (v: number) => v / 6.89476,
  // Density
  [`${UNITS.DENSITY_PPG}->${UNITS.DENSITY_KGM3}`]: (v: number) => v * 119.8264,
  [`${UNITS.DENSITY_KGM3}->${UNITS.DENSITY_PPG}`]: (v: number) => v / 119.8264,
  // Length
  [`${UNITS.LENGTH_IN}->${UNITS.LENGTH_MM}`]: (v: number) => v * 25.4,
  [`${UNITS.LENGTH_MM}->${UNITS.LENGTH_IN}`]: (v: number) => v / 25.4,
  [`${UNITS.LENGTH_FT}->${UNITS.LENGTH_M}`]: (v: number) => v * 0.3048,
  [`${UNITS.LENGTH_M}->${UNITS.LENGTH_FT}`]: (v: number) => v / 0.3048,
  // Mass per length
  [`${UNITS.MASS_PER_LENGTH_LBFT}->${UNITS.MASS_PER_LENGTH_KGM}`]: (v: number) => v * 1.48816,
  [`${UNITS.MASS_PER_LENGTH_KGM}->${UNITS.MASS_PER_LENGTH_LBFT}`]: (v: number) => v / 1.48816,
  // Force
  [`${UNITS.FORCE_KIPS}->${UNITS.FORCE_KN}`]: (v: number) => v * 4.44822,
  [`${UNITS.FORCE_KN}->${UNITS.FORCE_KIPS}`]: (v: number) => v / 4.44822,
  // Weight
  [`${UNITS.WEIGHT_LB}->${UNITS.WEIGHT_KG}`]: (v: number) => v * 0.453592,
  [`${UNITS.WEIGHT_KG}->${UNITS.WEIGHT_LB}`]: (v: number) => v / 0.453592,
};
